import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JourneyOption from '../../../shared/components/line_select/JourneyOption';

export default class JourneyOptionContainer extends Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        isDisabled: PropTypes.bool,
        isFocused: PropTypes.bool,
        isSelected: PropTypes.bool,
        onFocus: PropTypes.func,
        onSelect: PropTypes.func,
        item: PropTypes.object.isRequired
    };

    handleMouseDown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }

    handleMouseEnter(event) {
        this.props.onFocus(this.props.option, event);
    }

    handleMouseMove (event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }

    render () {
        const { item, ...others } = this.props;

        return (
            <JourneyOption
                {...others}
                option={item}
                onMouseDown={::this.handleMouseDown}
                onMouseEnter={::this.handleMouseEnter}
                onMouseMove={::this.handleMouseMove}
            />
        );
    }
}
